<div class="content-wrapper d-print-none">
    <div class="row">
        <div class="col-lg-12 grid-margin stretch-card">
            <div class="card">
                <div class="card-body">
                    <h4 class="card-title">My Drafts </h4>
                    <div class="table-responsive pt-3">
                        <nz-table #ManPowerTable [nzData]="ManPower" [nzPageSize]="50">
                            <thead>
                                <tr>
                                    <th>
                                        #
                                    </th>

                                    <th>
                                        Created Date
                                    </th>
                                    
                                    <th>
                                        Requester Name
                                    </th>

                                    <th>
                                        Requester Designation
                                    </th>

                                    <th>
                                        Required Role
                                    </th>

                                    <th>
                                        Requester Function
                                    </th>

                                    <th>
                                        Location
                                    </th>

                                    <!-- Add Delete column header -->
                                    <th>
                                        Actions
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let data of ManPowerTable.data; let i = index;" >
                                    <td>
                                        {{i+1}}
                                    </td>
                                    <td>
                                        {{ data.createdDate | date: 'dd MMMM yyy' }}
                                    </td>

                                    <td>
                                        {{data.requesterName}}
                                    </td>

                                    <td>
                                        {{data.requesterDesignation}}
                                    </td>

                                    <td>
                                        {{data.jobTitle}}
                                    </td>

                                    <td>
                                        {{data.requesterFunction}}
                                    </td>

                                    <td>
                                        {{data?.location}}
                                    </td>

                                    <!-- Add Delete Icon and Button -->
                                    <td style="display: flex; justify-content: space-between;">
                                        <!-- Edit Button with Tooltip -->
                                        <button class="btn btn-sm btn-primary" (click)="open(data)" data-bs-toggle="tooltip" title="Edit">
                                            <i class="fa fa-edit"></i>
                                        </button>
                                        
                                        <!-- Delete Button with Tooltip -->
                                        <button class="btn btn-sm btn-danger" (click)="deleteDraft(data.id)" data-bs-toggle="tooltip" title="Delete">
                                            <i class="fa fa-trash"></i>
                                        </button>
                                    </td>
                                    
                                </tr>
                            </tbody>
                        </nz-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
